import Placeholder from './Placeholder'

export * from './Placeholder'
export default Placeholder
